
export const statusData = [
  { name: "Evènement en cours", id: "progress", color: "#E3A322" },
  { name: "Fini", id: "finished", color: "#91C73C" },
  { name: "Suspendu", id: "creation", color: "#849191" },
];
